import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

createApp(App)
.use(router)
//.component('aw-menu', require('./components/Menu.vue').default)
.mount('#app')
